import { combineReducers } from "redux";
import profiles from './profiles';
import filters from './filters';

export default combineReducers({
    profiles,
    filters
})